export const DEMO_CONTENT = import.meta.env.VITE_DEMO_CONTENT === 'true'
export const CONTACT_EMAIL = 'hello@urbanpurr.com'

/**
 * Подложка карты — растровые тайлы CARTO Voyager.
 *
 * КЛЮЧ ОБЯЗАТЕЛЕН. С 2026 года CARTO рисует поверх тайлов водяной знак
 * «API key required», если ключа нет. Ключ подставляется на сборке из
 * `VITE_CARTO_KEY`; без него карта по-прежнему работает, просто с водяным
 * знаком — поэтому сборка не падает, а молча деградирует.
 *
 * Ключ неизбежно виден в собранном коде: тайлы запрашивает браузер, и спрятать
 * его негде. Поэтому в репозитории его нет — он живёт в `.env` сервера, а у
 * CARTO на него стоит ограничение по домену.
 *
 * Атрибуцию CARTO и OpenStreetMap убирать нельзя — это условие бесплатного
 * использования.
 */
const CARTO_KEY = import.meta.env.VITE_CARTO_KEY ?? ''

/**
 * Подложка под тему. В тёмной теме светлая карта светилась бы белым
 * прямоугольником посреди тёмной страницы — у CARTO для этого есть
 * отдельный стиль `dark_all`.
 */
export const basemapUrl = (dark) =>
  `https://{s}.basemaps.cartocdn.com/rastertiles/${dark ? 'dark_all' : 'voyager'}/{z}/{x}/{y}{r}.png` +
  (CARTO_KEY ? `?key=${CARTO_KEY}` : '')

export const BASEMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
